import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { view } from "@risingstack/react-easy-state";
import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Tooltip,
} from "@mui/material";
import {
  ArrowDropDown,
  CheckBox,
  CheckBoxOutlineBlank,
} from "@mui/icons-material";
import React from "react";
import _ from "lodash";
import { VariableSizeList } from "react-window";

const FacetItems = (props: any) => {
  const { data, onFilterProducts } = props;

  const [filters, setFilters] = React.useState<any>({
    Brand: [],
    Ingredients: [],
    Size: [],
  });

  const handleFilterToggle = async (key: string, item: string) => {
    const tempFilters = _.clone(filters);
    const currentIndex = tempFilters[key].indexOf(item);

    if (currentIndex === -1) {
      tempFilters[key].push(item);
    } else {
      tempFilters[key].splice(currentIndex, 1);
    }
    setFilters(tempFilters);
    onFilterProducts(tempFilters, key);
  };

  const getItemSize = (index: number) => {
    return 46;
  };

  return (
    <Stack sx={{ background: "#FFFFFF", padding: 2, overflow: "auto" }}>
      {data.map((p: any, index: any) => (
        <Accordion key={index} elevation={0} disableGutters>
          <AccordionSummary
            expandIcon={<ArrowDropDown />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ px: 0 }}
          >
            <Typography
              sx={{
                fontSize: 12,
                lineHeight: "16px",
                fontWeight: 500,
                color: "#6F7784",
              }}
            >
              {p.name}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>
            <VariableSizeList
              height={300}
              width={"100%"}
              itemSize={getItemSize}
              itemCount={p.facetDetails.length}
              overscanCount={5}
            >
              {({ index, style }) => (
                <ListItem
                  key={`${p.name}_${index}`}
                  component="div"
                  disablePadding
                  style={style}
                >
                  <ListItemButton
                    role={undefined}
                    onClick={() =>
                      handleFilterToggle(p.name, p.facetDetails[index].name)
                    }
                    dense
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={
                          filters[p.name].indexOf(
                            p.facetDetails[index].name
                          ) !== -1
                        }
                        icon={
                          <CheckBoxOutlineBlank
                            sx={{
                              color: "#6F7784",
                              borderRadius: "4px",
                              opacity: 0.6,
                            }}
                          />
                        }
                        checkedIcon={
                          <CheckBox
                            sx={{ color: "#077942", borderRadius: "4px" }}
                          />
                        }
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <Tooltip
                      title={`${p.facetDetails[index].name} (${p.facetDetails[index].count})`}
                    >
                      <ListItemText
                        disableTypography
                        primary={`${p.facetDetails[index].name} (${p.facetDetails[index].count})`}
                        sx={{
                          fontSize: 14,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      />
                    </Tooltip>
                  </ListItemButton>
                </ListItem>
              )}
            </VariableSizeList>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
};

export default view(FacetItems);
